.emptyState {
  justify-content: center;
  align-items: center;
  display: flex;
}

.emptyText {
  text-align: center;
}

.gridContainer {
  overflow: auto;
}
